import type { InboxNotification } from "@/types/inbox.types";

// Re-export from constants for backward compatibility
export { filterOptions, defaultTypeOrder } from "@/constants/inbox.constants";

export const mockNotifications: InboxNotification[] = [
  {
    id: "notif-1",
    type: "contract",
    title: "Contract requires signature",
    description: "Artist Recording Deal is awaiting your signature before Dec 20",
    priority: "high",
    status: "unread",
    timestamp: "2025-01-08T10:30:00Z",
    relativeTime: "2 hours ago",
    actionRequired: true,
    metadata: {
      entityId: "contract-1",
      entityName: "Artist Recording Deal",
      actor: "Legal Team",
      participants: ["You", "Adam Silver", "Roger Goodell"],
      relatedItems: [
        { id: "doc-1", name: "Master Agreement", type: "document" },
        { id: "deal-1", name: "Sony Music Partnership", type: "deal" },
      ],
      tags: ["urgent", "signature", "recording"],
      attachments: [
        { name: "Artist_Recording_Deal.pdf", size: "2.4 MB", type: "pdf" },
        { name: "Terms_Exhibit_A.pdf", size: "856 KB", type: "pdf" },
      ],
    },
  },
  {
    id: "notif-2",
    type: "deal",
    title: "Deal status updated",
    description: "Sony Music Partnership moved to In Progress",
    priority: "medium",
    status: "unread",
    timestamp: "2025-01-08T09:15:00Z",
    relativeTime: "3 hours ago",
    metadata: {
      entityId: "deal-1",
      entityName: "Sony Music Partnership",
      actor: "Adam Silver",
      participants: ["You", "Adam Silver", "Roger Goodell"],
      relatedItems: [{ id: "contract-1", name: "Artist Recording Deal", type: "contract" }],
      tags: ["partnership", "in-progress"],
    },
  },
  {
    id: "notif-3",
    type: "document",
    title: "Document shared with you",
    description: "Amendment #1 was shared by Legal Team for review",
    priority: "high",
    status: "unread",
    timestamp: "2025-01-08T08:00:00Z",
    relativeTime: "5 hours ago",
    actionRequired: true,
    metadata: {
      entityId: "doc-2",
      entityName: "Amendment #1",
      actor: "Legal Team",
      participants: ["You", "Legal Team", "Adam Silver"],
      relatedItems: [{ id: "contract-1", name: "Artist Recording Deal", type: "contract" }],
      tags: ["amendment", "review"],
      attachments: [{ name: "Amendment_001.pdf", size: "1.2 MB", type: "pdf" }],
    },
  },
  {
    id: "notif-4",
    type: "contract",
    title: "Contract analysis complete",
    description: "Producer Agreement analysis is ready for review",
    priority: "low",
    status: "unread",
    timestamp: "2025-01-07T16:30:00Z",
    relativeTime: "Yesterday",
    metadata: {
      entityId: "contract-2",
      entityName: "Producer Agreement",
      participants: ["You", "Roger Goodell"],
      relatedItems: [{ id: "deal-2", name: "Netflix Sync License", type: "deal" }],
      tags: ["analysis", "producer"],
    },
  },
  {
    id: "notif-5",
    type: "deal",
    title: "New comment on deal",
    description: "Roger Goodell commented on Netflix Sync License",
    priority: "medium",
    status: "read",
    timestamp: "2025-01-07T14:00:00Z",
    relativeTime: "Yesterday",
    metadata: {
      entityId: "deal-2",
      entityName: "Netflix Sync License",
      actor: "Roger Goodell",
      participants: ["You", "Roger Goodell", "Adam Silver"],
      relatedItems: [{ id: "contract-2", name: "Producer Agreement", type: "contract" }],
      tags: ["comment", "sync-license"],
    },
  },
  {
    id: "notif-6",
    type: "document",
    title: "Document uploaded",
    description: "Territory Rights Exhibit was uploaded to Sony Music Partnership",
    priority: "low",
    status: "read",
    timestamp: "2025-01-06T11:00:00Z",
    relativeTime: "2 days ago",
    metadata: {
      entityId: "doc-5",
      entityName: "Territory Rights Exhibit",
      actor: "You",
      participants: ["You", "Adam Silver"],
      relatedItems: [{ id: "deal-1", name: "Sony Music Partnership", type: "deal" }],
      tags: ["exhibit", "territory"],
      attachments: [{ name: "Territory_Rights_Exhibit.pdf", size: "3.1 MB", type: "pdf" }],
    },
  },
  {
    id: "notif-7",
    type: "contract",
    title: "Contract expiring soon",
    description: "Brand Partnership / NIL Deal expires in 30 days",
    priority: "medium",
    status: "read",
    timestamp: "2025-01-05T09:00:00Z",
    relativeTime: "3 days ago",
    actionRequired: true,
    metadata: {
      entityId: "contract-3",
      entityName: "Brand Partnership / NIL Deal",
      participants: ["You", "Adam Silver"],
      relatedItems: [],
      tags: ["expiring", "brand-partnership"],
    },
  },
  {
    id: "notif-8",
    type: "deal",
    title: "Deal completed",
    description: "Spotify Playlist Placement has been marked as complete",
    priority: "low",
    status: "read",
    timestamp: "2025-01-04T15:00:00Z",
    relativeTime: "4 days ago",
    metadata: {
      entityId: "deal-4",
      entityName: "Spotify Playlist Placement",
      participants: ["You", "Roger Goodell"],
      relatedItems: [],
      tags: ["completed", "playlist"],
    },
  },
];
